import { Component, ElementRef, HostListener, ViewChild } from '@angular/core';
import { NgbDate, NgbDateStruct } from '@ng-bootstrap/ng-bootstrap';
import { NgbDateParserFormatter } from '@ng-bootstrap/ng-bootstrap';
import KeenSlider, { KeenSliderInstance, KeenSliderPlugin } from 'keen-slider';

function ThumbnailPlugin(main: KeenSliderInstance): KeenSliderPlugin {
  return (slider) => {
    function removeActive() {
      slider.slides.forEach((slide) => {
        slide.classList.remove('active');
      });
    }
    function addActive(idx: number) {
      slider.slides[idx].classList.add('active');
    }

    function addClickEvents() {
      slider.slides.forEach((slide, idx) => {
        slide.addEventListener('click', () => {
          main.moveToIdx(idx);
        });
      });
    }

    slider.on('created', () => {
      addActive(slider.track.details.rel);
      addClickEvents();
      main.on('animationStarted', (main) => {
        removeActive();
        const next = main.animator.targetIdx || 0;
        addActive(main.track.absToRel(next));
        slider.moveToIdx(Math.min(slider.track.details.maxIdx, next));
      });
    });
  };
}

@Component({
  selector: 'app-ui-business-detail',
  templateUrl: './ui-business-detail.component.html',
  styleUrls: ['./ui-business-detail.component.scss'],
})
export class UiBusinessDetailComponent {
  model!: NgbDateStruct;
  constructor(private ngbDateParserFormatter: NgbDateParserFormatter) {}

  getFormattedDate(date: NgbDateStruct): string {
    if (!date) return '';
    const jsDate = new Date(date.year, date.month - 1, date.day);
    const days = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'];
    const months = [
      'Jan',
      'Feb',
      'Mar',
      'Apr',
      'May',
      'Jun',
      'Jul',
      'Aug',
      'Sep',
      'Oct',
      'Nov',
      'Dec',
    ];

    const day = days[jsDate.getDay()];
    const month = months[jsDate.getMonth()];
    const year = jsDate.getFullYear();

    // Formatted date string
    return `${day}, ${month} ${jsDate.getDate()}`;
  }

  peopleSelect!: number;
  timeSelect!: number;
  peoples = [
    { id: 1, name: '2 people' },
    { id: 2, name: '4 people' },
    { id: 3, name: '8 people' },
  ];

  times = [
    { id: 1, name: '8:00 pm' },
    { id: 2, name: '9:00 pm' },
    { id: 3, name: '10:00 pm' },
  ];

  activeDishPanel = 2;
  active = 'top';

  // Slider With Thumb Code
  @ViewChild('sliderRef') sliderRef!: ElementRef<HTMLElement>;
  @ViewChild('thumbnailRef') thumbnailRef!: ElementRef<HTMLElement>;
  @ViewChild('sliderRefInner') sliderRefInner!: ElementRef<HTMLElement>;

  slider!: KeenSliderInstance;
  thumbnailSlider!: KeenSliderInstance;
  currentSlide: number = 0;
  sliderInner!: KeenSliderInstance;

  @HostListener('window:resize', ['$event'])
  onResize(): void {
    setTimeout(() => {
      this.sliderInner.update();
    }, 200);
  }

  ngAfterViewInit() {
    this.slider = new KeenSlider(
      this.sliderRef.nativeElement,
      {
        initial: this.currentSlide,
        slideChanged: (s) => {
          this.currentSlide = s.track.details.rel;
        },
        rubberband: false,
        breakpoints: {
          '(max-width: 575px)': {
            slides: { spacing: 12 },
          },
        },
        selector: '.top-slider > .keen-slider__slide',
      },
      [
        (slider) => {
          slider.on('created', (s) => {
            const slideElements = s.slides;
            slideElements.forEach((slide, index) => {
              if (index === this.currentSlide) {
                slide.classList.add('active');
              } else {
                slide.classList.remove('active');
              }
            });
          });
          slider.on('slideChanged', (s) => {
            const slideElements = s.slides;
            slideElements.forEach((slide, index) => {
              if (index === s.track.details.abs) {
                slide.classList.add('active');
              } else {
                slide.classList.remove('active');
              }
            });
          });
        },
      ]
    );

    this.thumbnailSlider = new KeenSlider(
      this.thumbnailRef.nativeElement,
      {
        initial: 0,
        rubberband: false,
        slides: {
          perView: 4,
          spacing: 0,
        },
        breakpoints: {
          '(max-width: 575px)': {
            slides: { perView: 4, spacing: 8 },
          },
        },
      },
      [ThumbnailPlugin(this.slider)]
    );

    setTimeout(() => {
      this.sliderInner = new KeenSlider(this.sliderRefInner.nativeElement, {
        rubberband: false,
        slides: {
          perView: 1,
        },
      });
    }, 300);
  }
  ngOnDestroy() {
    if (this.slider) this.slider.destroy();
    if (this.thumbnailSlider) this.thumbnailSlider.destroy();
    if (this.sliderInner) this.sliderInner.destroy();
  }
}
